import LoadingActionTypes from "./action-types.ts";

export const loadingState = (payload) => ({
    type: LoadingActionTypes.LOADING,
    payload,
});